import {
  Avatar,
  Button,
  Card,
  CardBody,
  CardHeader,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  checkIfImageExists,
  formatKeyword,
  formatPrice,
  formatSource,
  friendlyListingTitle,
  friendlyTimeFormat,
} from "../utils";
import { DataContext } from "../context/DataContext";
import { useSearch } from "../context/SearchContext";

export function SearchListings() {
  const { searchText, setSearchText, searchResults, loading, performSearch } = useSearch();
  const [checkedImages, setCheckedImages] = useState({});
  const dataContext = useContext(DataContext);

  useEffect(() => {
    if (searchResults) {
      for (let i = 0; i < searchResults.length; i++) {
        const imageURL = searchResults[i].imageURL;
        checkIfImageExists(imageURL, (exists) => {
          const checkedURL = exists ? imageURL : "/small-airplane.png";
          setCheckedImages((cur) => {
            cur[searchResults[i].uniqueListingId] = checkedURL;
            return { ...cur };
          });
        });
      }
    }
  }, [searchResults]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter'){
      handleSearch()
    }
  }

  const handleSearch = async () => {
    await performSearch(searchText);
  };

  return (
    <div className="mt-12 mb-12 ">
        <Card>
          <CardHeader className="mb-4 p-2 bg-[#041c2c]">
            <Typography
              variant="h5"
              color="blue-gray"
              className="text-white p-5"
            >
              Search Listings
            </Typography>
          </CardHeader>
          <CardBody className="min-h-200">
            <div className="flex items-center gap-4 max-w-md">
              <div className="flex-1">
                <Input
                  label="Registration"
                  value={searchText}
                  onKeyDown={handleKeyPress}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <Button className="bg-lma-dark hover:bg-lma-gold shrink-0" onClick={handleSearch} disabled={loading}>
                {loading ? <Spinner className="h-4 w-4" /> : "Search"}
              </Button>
            </div>
            <div className="mt-12 mb-8 flex flex-col gap-12">
              <table className="w-full min-w-[640px] table-auto">
                <thead>
                  <tr>
                    {[
                      "Title",
                      "price",
                      "Manufacturer",
                      "Model",
                      // "listing ID",
                      "source",
                      "first seen",
                      "last seen",
                    ].map((el) => (
                      <th
                        key={el}
                        className="border-b border-gray-200 py-3 px-5 text-left"
                      >
                        <Typography
                          variant="small"
                          className="text-[11px] font-bold uppercase text-lma-gray"
                        >
                          {el}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((doc, index) => {
                    const className = `py-3 px-5 ${
                      index === searchResults.length - 1
                        ? ""
                        : "border-b border-gray-200"
                    }`;

                    return (
                      <tr key={`row_rel${index}`}>
                        <td className={className}>
                          <div className="flex items-center gap-4">
                            <Avatar src={checkedImages[doc.uniqueListingId]} alt={index} size="sm" />
                            <Link
                              to={`/dashboard/listing-details/${doc.uniqueListingId}`}
                            >
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-bold"
                              >
                                {friendlyListingTitle(dataContext, doc)}
                              </Typography>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className=""
                              >
                                {doc.reg}
                              </Typography>
                            </Link>
                          </div>
                        </td>
                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {formatPrice(doc.price, doc.currency)}
                          </Typography>
                        </td>
                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {formatKeyword(doc.manufacturer)}
                          </Typography>
                        </td>
                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {doc.formattedModel || '-'}
                          </Typography>
                        </td>

                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {formatSource(doc.source)}
                          </Typography>
                        </td>
                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {friendlyTimeFormat(doc.first_seen)}
                          </Typography>
                        </td>
                        <td className={className}>
                          <Typography
                            variant="small"
                            className="text-xs font-medium text-lma-gray"
                          >
                            {friendlyTimeFormat(doc.last_seen)}
                          </Typography>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
    </div>
  );
}
